import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchChangeSelectedFileInfo,
  selector as fileStoreSelector,
} from "../../../store/FileStore";
import useStyles from "../useStyles";

import FileActionTable from "./FileActionTable";

/**
 * ファイルアクションダイアログコンポーネント.
 *
 * @param {string} title タイトル
 * @param {string | object} message メッセージ
 * @param {string} buttonLabel ボタンラベル
 * @param {boolean} isOpenDialog ダイアログの表示状態
 * @param {function} onAction ダイアログアクション時の処理
 * @param {function} onClose ダイアログクローズ時の処理
 * @return {object} コンポーネント
 */
function FileActionDialog(props) {
  // 引数
  const {
    // タイトル
    title,
    // メッセージ
    message,
    // ボタンラベル
    buttonLabel,
    // ダイアログの表示状態（true：表示、false：非表示）
    isOpenDialog,
    // ダイアログアクション時の処理
    onAction,
    // ダイアログクローズ時の処理
    onClose,
  } = props;

  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  const {
    // 選択済みファイル情報一覧
    selectedFileInfos,
  } = useSelector(fileStoreSelector);

  // OKボタン押下時の処理
  const handleActionButtonClick = () => {
    onAction();
    onClose();
  };

  // 選択済みファイルの解除ボタン押下時の処理
  const handleFileCancelButtonClick = (fileInfo) => {
    dispatch(
      fetchChangeSelectedFileInfo({
        fileInfo,
        checked: false,
      })
    );
  };

  return (
    <Dialog open={isOpenDialog} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={styles.dialogContent}>{message}</DialogContent>
      <DialogContent className={styles.dialogContent}>
        <FileActionTable
          fileInfos={selectedFileInfos}
          onCancel={handleFileCancelButtonClick}
        />
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button color="default" onClick={onClose}>
          CANCEL
        </Button>
        <Button
          color="primary"
          onClick={handleActionButtonClick}
          disabled={!selectedFileInfos.length}
        >
          {buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FileActionDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonLabel: PropTypes.string.isRequired,
  isOpenDialog: PropTypes.bool.isRequired,
  onAction: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

FileActionDialog.defaultProps = {
  message: "",
};

export default FileActionDialog;
